module.exports = __webpack_public_path__ + "img/jasonpreece2.af5be35c.jpg";